import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  getCurrentInstance,
  watch,
} from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import useModal from '@/@core/components/base-modal/hooks/useModal'
import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import { privilegeCriteriaModel } from '@/models/privilege/privilege-form'
import { PRIVILEGE_TYPE } from "@/configs/privilege/privilege";
import tagModel from '@/models/tag/tag-list'

export default function useManageCriteriaListModal(props) {
  const { fetchDetail } = privilegeCriteriaModel();
  const { fetchTagList } = tagModel();
  const { openModal, closeModal } = useModal();
  const {
    openSuccessModal,
    openDefaultErrorModal,
    openWarningModal,
  } = useValidationModal();

  const vm = getCurrentInstance().proxy;

  const formData = reactive({
    criteriaGroupId: 0,
    criteriaType: 2,
    priority: "",
    name: "",
    tag: "",
    tier: "",
    point: "",
    note: "",
    isVisible: true,
    isRedeemable: true,
    isIssuable: true,
    pointMode: 1,
  });

  const criteriaTypeOptions = ref([
    { text: "Default", value: 1 },
    { text: "Custom", value: 2 },
  ]);

  const booleanTypeOptions = ref([
    { text: "Yes", value: true },
    { text: "No", value: false },
  ]);

  const optionData = reactive({
    tagList: [],
  });

  const fetchTagListData = () => {
    window.$loading(true);
    store
      .dispatch("api/apiRequest", fetchTagList)
      .then((resp) => {
        if (resp.data.tag_list.length > 0) {
          optionData.tagList = resp.data.tag_list.map((obj) => ({
            seq: obj.seq,
            label: obj.tag,
          }));
        }
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const fetchDetailData = () => {
    window.$loading(true);
    fetchDetail.payload.Privilege_Id = props.formDataObj.privilegeId;
    fetchDetail.payload.Criteria_Group_Id = props.formDataObj.selectId;

    store
      .dispatch("api/apiRequest", fetchDetail)
      .then(async (resp) => {
        const respData = resp.data.resp;
        formData.criteriaGroupId = respData.criteria_group_id;
        formData.criteriaType = respData.type;
        formData.priority = respData.priority.toString();
        formData.name = respData.name;
        formData.tag =
          respData.tag_list.length > 0
            ? respData.tag_list.map((obj) => ({
                seq: obj.seq,
                label: obj.tag,
                condition: obj.condition,
              }))
            : [];
        formData.tier =
          respData.tier_list.length > 0
            ? respData.tier_list.map((obj) => ({
                seq: obj.seq,
                label: obj.tier,
                condition: obj.condition,
              }))
            : [];
        formData.point = respData.point.toString();
        formData.note = respData.note;
        formData.isVisible = respData.isvisible;
        formData.isIssuable = respData.isissuable;
        formData.isRedeemable = respData.isredeemable;
        formData.pointMode = respData.point_mode != 0 ? respData.point_mode : 2;
      })
      .catch((err) => {
        openDefaultErrorModal();
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onNumberInput = (ev, formDataValue) => {
    vm.$nextTick(() => {
      const inputNumber = ev.replace(/\D/g, "");
      formData[formDataValue] = inputNumber;
    });
  };

  const onSubmitModal = () => {
    //check Minimum tansfer point
    if (formExchange.type == PRIVILEGE_TYPE.EXCHANGE){
      if(formData.point < formExchange.minValue){
        openWarningModal(
          'Point Transfer',`Point น้อยกว่าค่า Minimum ที่กำหนด (${formExchange.minValue} Point)`,
          null,null,null,'ปิด',false,true,
        );
        return false;
      }
    }

    vm.$emit('onSubmit', formData, props.isEdit)
  }

  const fetchCriteriaData = () => {
    fetchTagListData();
    if (props.formDataObj.isNoDefault) {
      formData.criteriaType = 1;
      formData.name = "Default";
    }
    if (props.isEdit) fetchDetailData();
  };

  const formExchange = reactive({
    type: "",
    pointRef: 0,
    valueRef: 0,
    minValue: 0,
    stepValue: 0,
  });

  
  let formDataExchange = JSON.parse(localStorage.getItem("dataLocalStorage"))
  if(formDataExchange){
    let formDataObj = formDataExchange?.find((o)=> {
      return o
    })

    formExchange.type = formDataObj.exchangeType;
    formData.point = parseInt(formDataObj.exChangePoint);
    formExchange.stepValue = formDataObj.exchangeStepValue;
    formExchange.minValue = formDataObj.exchangeMinValue
  }

  
  const updatePoint = (number) => {
    formData.point = number
  }

  return {
    formData,
    criteriaTypeOptions,
    booleanTypeOptions,
    optionData,
    fetchCriteriaData,
    onSubmitModal,
    onNumberInput,
    updatePoint,
    formExchange
  }
}
